import { useCallback, useSyncExternalStore } from 'react';

import { readItem, subscribeStorage, type StorageArea } from '../api/docs-storage';

/** The raw string stored under `key` (null without one), re-read on every docs storage write. */
export function useBrowserStorage(area: StorageArea, key: string | null): string | null {
  const snapshot = useCallback(() => (key ? readItem(area, key) : null), [area, key]);
  return useSyncExternalStore(subscribeStorage, snapshot, () => null);
}
